export default "__VITE_ASSET__C8rLCgZ9__"